module.exports = __webpack_public_path__ + "static/media/checkoutbg_center_active.f861e9c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/checkoutbg_center_active.svg
// module id = 693
// module chunks = 0